import * as o from "react";
import { c as e } from "../createReactComponent-58f9bea8.mjs";
import { b as a, r } from "../icon-c572aa57.mjs";
import { c as I, a as x, I as f } from "../icon-c572aa57.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
const i = e({ tagName: "ex-icon", elementClass: a, react: o, events: {}, displayName: "ExIcon", registerWebComponent: r });
export {
  i as ExIcon,
  I as ICONS,
  a as Icon,
  x as IconSize,
  f as IconVariant,
  r as register
};
